<!-- <a (click)="deleteUserFromGroupRole()">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_delete}}</mat-icon>
</a> -->
<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: -3px;margin-left: 0px" matTooltip="Benutzer aus Rolle entfernen"
            (click)="deleteUserFromGroupRole()">Löschen</button>
</a>
